import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2e5dfe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cw-lobby" }
const _hoisted_2 = { class: "cw-lobby-title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "cw-actions-holder" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.hasLobbyData)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(this.title), 1),
          _createElementVNode("div", {
            class: "cw-lobby-description",
            innerHTML: this.messageAsHtml
          }, null, 8, _hoisted_3),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.actions, (action) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "cw-action",
                key: action.id
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (this.actionClick(action)),
                  class: _normalizeClass({ 'use-custom-padding': this.useCustomPadding })
                }, _toDisplayString(this.actionText(action)), 11, _hoisted_5)
              ]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}